import { createSafeContext } from '@mantine/utils';

const [GridProvider, useGridContext] = createSafeContext("Grid component was not found in tree");

export { GridProvider, useGridContext };
//# sourceMappingURL=Grid.context.js.map
